import React from "react";
import {
    Modal,
    ModalClose,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from "#app/interface/modal/Modal";
import { Body, Title2, Title3 } from "#app/components/texts/Typography";

export interface PolicyModalProps {
    id?: string;
    show?: boolean;
    onClose?: () => void;
}

const PolicyModal: React.FC<PolicyModalProps> = ({ id, show, onClose }) => {
    const handleClose = () => {
        onClose?.();
        Modal.handleClose();
    };

    return (
        <Modal id={id} show={show} trigger="">
            <ModalHeader>
                <Title2 white>Политика конфиденциальности</Title2>
                <ModalClose id="close-icon" onClick={handleClose}>
                    <div />
                </ModalClose>
            </ModalHeader>
            <ModalContent>
                <Title2 white>
                    Политика конфиденциальности интернет-сайта blackswan.finance
                </Title2>
                <br />
                <br />
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Body white left inline>
                        г. Ярославль
                    </Body>
                    <Body white left right inline>
                        "1" сентября 2023 г.
                    </Body>
                </div>
                <br />
                <Body white left>
                    Настоящая Политика конфиденциальности персональных данных (далее - Политика
                    конфиденциальности) является неотъемлемой частью Публичной оферты,
                    размещенной на сайте в сети Интернет по адресу: www.blackswan.finance (далее
                    - Сайт).
                </Body>
                <Body white left>
                    Использование сервисов Сайта означает безоговорочное согласие Пользователя с
                    настоящей Политикой и указанными в ней условиями обработки его персональной
                    информации; в случае несогласия с этими условиями Пользователь должен
                    воздержаться от использования сервисов.
                </Body>
                <br />
                <Title3 white>1. ОБЩИЕ ПОЛОЖЕНИЯ</Title3>
                <br />
                <Body white left>
                    1.1. В рамках настоящей Политики под персональной информацией Пользователя
                    понимаются:
                </Body>
                <Body white left>
                    1.1.1. Персональная информация, которую Пользователь предоставляет о себе
                    самостоятельно при регистрации (создании учетной записи) или в процессе
                    использования Сервисов, включая персональные данные Пользователя.
                    Обязательная для предоставления Сервисов информация помечена специальным
                    образом.
                </Body>
                <Body white left>
                    1.1.2. Данные, которые автоматически передаются сервисам Сайта в процессе их
                    использования с помощью установленного на устройстве Пользователя
                    программного обеспечения, в том числе IP-адрес, данные файлов cookie,
                    информация о браузере Пользователя (или иной программе, с помощью которой
                    осуществляется доступ к сервисам), технические характеристики оборудования и
                    программного обеспечения, используемых Пользователем, дата и время доступа к
                    сервисам, адреса запрашиваемых страниц и иная подобная информация.
                </Body>
                <Body white left>
                    1.1.3. Настоящая Политика конфиденциальности применяется только к Сайту
                    www.blackswan.finance. Сайт www.blackswan.finance не контролирует и не несет
                    ответственности за сайты третьих лиц, на которые Пользователь может перейти
                    по ссылкам, доступным на Сайте www.blackswan.finance.
                </Body>
                <br />
                <Title3 white>2. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ</Title3>
                <br />
                <Body white left>
                    2.1. Сайт собирает и хранит только ту персональную информацию, которая
                    необходима для предоставления сервисов или исполнения соглашений и договоров
                    с Пользователем, за исключением случаев, когда законодательством
                    предусмотрено обязательное хранение персональной информации в течение
                    определенного законом срока.
                </Body>
                <Body white left>
                    В случае получения уведомления от Пользователя об отзыве согласия на
                    обработку персональных данных Сайт прекращает обработку персональных данных
                    Пользователя в срок, не превышающий 10 рабочих дней с момента получения.
                </Body>
                <Body white left>
                    Уведомление об отзыве согласия на обработку персональных данных направляется
                    на адрес электронной почты: info@blackswan.finance, а также путем
                    письменного обращения по юридическому адресу: 150000, Ярославская область,
                    город Ярославль, Первомайская ул., д. 7а, помещ. 1 .
                </Body>
                <Body white left>
                    2.2. Персональную информацию Пользователя Сайт обрабатывает в следующих
                    целях:
                </Body>
                <Body white left>
                    2.2.1. Идентификации Пользователя, зарегистрированного на Сайте, для работы
                    в личном кабинете.
                </Body>
                <Body white left>
                    2.2.2. Предоставления Пользователю доступа к персонализированным ресурсам
                    Сайта.
                </Body>
                <Body white left>
                    2.2.3. Установления с Пользователем обратной связи, включая направление
                    уведомлений, запросов, касающихся использования Сайта, оказания услуг,
                    обработку запросов и заявок от Пользователя.
                </Body>
                <Body white left>
                    2.2.4. Определения места нахождения Пользователя для обеспечения
                    безопасности, предотвращения мошенничества.
                </Body>
                <Body white left>
                    2.2.5. Подтверждения достоверности и полноты персональных данных,
                    предоставленных Пользователем.
                </Body>
                <Body white left>
                    2.2.6. Создания учетной записи для работы в личном кабинете, если
                    Пользователь дал согласие на создание учетной записи.
                </Body>
                <Body white left>
                    2.2.7. Уведомления Пользователя Сайта об изменениях на сайте, в личных
                    данных и маркетинговых активностях.
                </Body>
                <Body white left>
                    2.2.8. Предоставления Пользователю эффективной клиентской и технической
                    поддержки при возникновении проблем, связанных с использованием Сайта.
                </Body>
                <Body white left>
                    2.2.9. Осуществления рекламной деятельности с согласия Пользователя.
                </Body>
                <br />
                <Title3 white>
                    3. УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ И ЕЕ ПЕРЕДАЧИ
                    ТРЕТЬИМ ЛИЦАМ
                </Title3>
                <br />
                <Body white left>
                    3.1. Сайт хранит персональную информацию Пользователей в соответствии с
                    внутренними регламентами конкретных сервисов.
                </Body>
                <Body white left>
                    3.2. В отношении персональной информации Пользователя сохраняется ее
                    конфиденциальность, кроме случаев добровольного предоставления Пользователем
                    информации о себе для общего доступа неограниченному кругу лиц. При
                    использовании отдельных сервисов Пользователь соглашается с тем, что
                    определенная часть его персональной информации становится общедоступной.
                </Body>
                <Body white left>
                    3.3. Сайт вправе передать персональную информацию Пользователя третьим лицам
                    в следующих случаях:
                </Body>
                <Body white left>
                    3.3.1. Пользователь выразил согласие на такие действия.
                </Body>
                <Body white left>
                    3.3.2. Передача необходима для использования Пользователем определенного
                    сервиса либо для исполнения определенного соглашения или договора с
                    Пользователем.
                </Body>
                <Body white left>
                    3.3.4. Передача предусмотрена российским или иным применимым
                    законодательством в рамках установленной законодательством процедуры.
                </Body>
                <Body white left>
                    3.3.5. В случае продажи Сайта к приобретателю переходят все обязательства по
                    соблюдению условий настоящей Политики применительно к полученной им
                    персональной информации.
                </Body>
                <Body white left>
                    3.4. Обработка персональных данных Пользователя осуществляется без
                    ограничения срока следующими способами: сбор, запись, систематизация,
                    накопление, хранение, уточнение (обновление, изменение), извлечение,
                    использование, передача (распространение, предоставление, доступ),
                    обезличивание, блокирование, удаление, уничтожение персональных данных, в
                    том числе в информационных системах персональных данных с использованием
                    средств автоматизации или без использования таких средств. Обработка
                    персональных данных Пользователей осуществляется в соответствии с
                    Федеральным законом от 27.07.2006 N 152-ФЗ "О персональных данных".
                </Body>
                <Body white left>
                    3.5. При утрате или разглашении персональных данных Администрация Сайта
                    информирует Пользователя об утрате или разглашении персональных данных.
                </Body>
                <Body white left>
                    3.6. Администрация Сайта принимает необходимые организационные и технические
                    меры для защиты персональной информации Пользователя от неправомерного или
                    случайного доступа, уничтожения, изменения, блокирования, копирования,
                    распространения, а также от иных неправомерных действий третьих лиц.
                </Body>
                <Body white left>
                    3.7. Администрация Сайта совместно с Пользователем принимает все необходимые
                    меры по предотвращению убытков или иных отрицательных последствий, вызванных
                    утратой или разглашением персональных данных Пользователя.
                </Body>
                <br />
                <Title3 white>4. ОБЯЗАТЕЛЬСТВА СТОРОН</Title3>
                <br />
                <Body white left>
                    4.1. Пользователь обязан:
                </Body>
                <Body white left>
                    4.1.1. Предоставить информацию о персональных данных, необходимую для
                    пользования Сайтом.
                </Body>
                <Body white left>
                    4.1.2. Обновлять, дополнять предоставленную информацию о персональных данных
                    в случае изменения данной информации.
                </Body>
                <Body white left>
                    4.2. Администрация Сайта обязана:
                </Body>
                <Body white left>
                    4.2.1. Использовать полученную информацию исключительно для целей, указанных
                    в настоящей Политике конфиденциальности.
                </Body>
                <Body white left>
                    4.2.2. Обеспечить хранение конфиденциальной информации в тайне, не
                    разглашать без предварительного письменного разрешения Пользователя, а также
                    не осуществлять продажу, обмен, опубликование либо разглашение иными
                    возможными способами переданных персональных данных Пользователя, за
                    исключением предусмотренных настоящей Политикой конфиденциальности.
                </Body>
                <Body white left>
                    4.2.3. Для обеспечения защиты персональных данных Пользователя при их
                    обработке приняты следующие правовые, организационные и технические меры от
                    несанкционированного, неправомерного или случайного доступа к персональным
                    данным, уничтожения, изменения, блокирования, копирования, предоставления,
                    распространения персональных данных, а также от иных неправомерных действий
                    в отношении персональных данных: ограничение доступа сотрудников, шифрование
                    данных, регулярное обновление ПО, аудит безопасности.
                </Body>
                <Body white left>
                    4.2.4. Осуществить блокирование персональных данных, относящихся к
                    соответствующему Пользователю, с момента обращения или запроса Пользователя
                    или его законного представителя либо уполномоченного органа по защите прав
                    субъектов персональных данных на период проверки в случае выявления
                    недостоверных персональных данных или неправомерных действий.
                </Body>
                <br />
                <Title3 white>5. ОТВЕТСТВЕННОСТЬ СТОРОН</Title3>
                <br />
                <Body white left>
                    5.1. Администрация Сайта, не исполнившая свои обязательства, несет
                    ответственность за убытки, понесенные Пользователем в связи с неправомерным
                    использованием персональных данных, в соответствии с законодательством
                    Российской Федерации.
                </Body>
                <Body white left>
                    5.2. В случае утраты или разглашения конфиденциальной информации
                    Администрация Сайта не несет ответственности, если данная конфиденциальная
                    информация:
                </Body>
                <Body white left>
                    5.2.1. Стала публичным достоянием до ее утраты или разглашения.
                </Body>
                <Body white left>
                    5.2.2. Была получена от третьей стороны до момента ее получения
                    Администрацией Сайта.
                </Body>
                <Body white left>
                    5.2.3. Была разглашена с согласия Пользователя.
                </Body>
                <br />
                <Title3 white>6. РАЗРЕШЕНИЕ СПОРОВ</Title3>
                <br />
                <Body white left>
                    6.1. До обращения в суд с иском по спорам, возникающим из отношений между
                    Пользователем Сайта и Администрацией Сайта, обязательным является
                    предъявление претензии (письменного предложения о добровольном
                    урегулировании спора).
                </Body>
                <Body white left>
                    6.2. Получатель претензии в течение 30 календарных дней со дня получения
                    претензии письменно уведомляет заявителя претензии о результатах
                    рассмотрения претензии.
                </Body>
                <Body white left>
                    6.3. При недостижении соглашения спор будет передан на рассмотрение в суд в
                    соответствии с действующим законодательством Российской Федерации.
                </Body>
                <Body white left>
                    6.4. К настоящей Политике конфиденциальности и отношениям между
                    Пользователем и Администрацией Сайта применяется действующее
                    законодательство Российской Федерации.
                </Body>
                <br />
                <Title3 white>7. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</Title3>
                <br />
                <Body white left>
                    7.1. Администрация Сайта вправе вносить изменения в настоящую Политику
                    конфиденциальности без согласия Пользователя.
                </Body>
                <Body white left>
                    7.2. Новая Политика конфиденциальности вступает в силу с момента ее
                    размещения на Сайте, если иное не предусмотрено новой редакцией Политики
                    конфиденциальности.
                </Body>
                <Body white left>
                    7.3. Все предложения или вопросы по настоящей Политике конфиденциальности
                    следует сообщать info@blackswan.finance.
                </Body>
                <Body white left>
                    7.4. Действующая Политика конфиденциальности размещена на странице по
                    адресу:{" "}
                    <a href={"/policy"} target="_blank" rel="noreferrer">
                        https://blackswan.finance/policy
                    </a>
                    .
                </Body>
                <Body white left>
                    7.5. Настоящая Политика конфиденциальности является неотъемлемой частью
                    Публичной оферты и Соглашения об использовании Сайта, размещенных на
                    странице по адресу: https://blackswan.finance/.
                </Body>
            </ModalContent>
            <ModalFooter />
        </Modal>
    );
};

export default PolicyModal;
